"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvertableSelectAllCheckbox = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_intl_1 = require("react-intl");
/**
 * @internal
 */
function InvertableSelectAllCheckbox(props) {
    var isVisible = props.isVisible, checked = props.checked, onToggle = props.onToggle, isFiltered = props.isFiltered, totalItemsCount = props.totalItemsCount, isPartialSelection = props.isPartialSelection;
    var intl = react_intl_1.useIntl();
    var handleToggle = react_1.useCallback(function (_e) {
        onToggle();
    }, [onToggle]);
    var checkboxClasses = classnames_1.default("input-checkbox", "gd-checkbox-selection", {
        "checkbox-indefinite": isPartialSelection,
    });
    var labelClasses = classnames_1.default("input-checkbox-label", "s-select-all-checkbox");
    if (!isVisible) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "gd-invertable-select-all-checkbox" },
        react_1.default.createElement("label", { className: labelClasses },
            react_1.default.createElement("input", { readOnly: true, type: "checkbox", className: checkboxClasses, checked: checked, onChange: handleToggle }),
            react_1.default.createElement("span", { className: "input-label-text" },
                react_1.default.createElement("span", { className: classnames_1.default("gd-list-all-checkbox", { "gd-list-all-checkbox-checked": checked }) },
                    intl.formatMessage({ id: "gs.list.all" }),
                    isFiltered
                        ? " " + intl.formatMessage({
                            id: "gs.list.searchResults",
                        })
                        : null),
                react_1.default.createElement("span", { className: "gd-list-actions-selection-size s-list-search-selection-size" }, "(" + totalItemsCount + ")")))));
}
exports.InvertableSelectAllCheckbox = InvertableSelectAllCheckbox;
//# sourceMappingURL=InvertableSelectAllCheckbox.js.map